import * as React from 'react';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';
import { ErrorsForm } from '@modules/errors/ErrorsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const errorsUrl = '/metropolis/api/errors';
export const errorsLabel = 'Chyby';
export const errorsPath = '/administration/errors';
export const errorsGridName = 'ErrorsGrid';
export const ErrorsGrid = compose(
  withRouter,
  setDisplayName(errorsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: errorsLabel }]),
  withColumns(Agenda.ERRORS),
  withProps(({ history, columns }) => ({
    name: errorsGridName,
    url: errorsUrl,
    Form: ErrorsForm,
    dialog: true,
    gridProps: {
      columns,
      filterRow: true,
      history,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.ERRORS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/errors/ErrorsGrid.tsx